<agpr-dialog-container
    [id]="id"
    [heading]="'Briefings.shareCanvas.heading.shareCanvas'"
    [modal]="true"
    (close)="closeDialog()"
>
    <agpr-scroll-panel>
        <div class="agpr-shareCanvasDialogContainer">
            <div class="agpr-shareCanvasDialog-message">
                <span>{{ 'Briefings.shareCanvas.message' | localize }}</span>
                <span class="agpr-shareCanvasDialog-message-breifingName">{{_briefing.name}}</span>
            </div>
            <div class="agpr-shareCanvasDialog-header">
                {{ 'Briefings.shareCanvas.heading.sendTo' | localize }}
            </div>
            <div class="agpr-inputGroup">
                <label
                    class="agpr-shareCanvasDialog-inputLabel"
                    for="mailingLists.picker"
                >
                    {{ 'Briefings.input.mailingLists' | localize }}
                </label>
                <agpr-mailing-list-picker
                    class="agpr-shareCanvasDialog-mailingList"
                    [(ngModel)]="mailingListIds"
                    (ngModelChange)="mailingListChanged()"
                    ariaDescribedBy="mailingList_errors"
                    [ariaInvalid]="mailingListCountError"
                ></agpr-mailing-list-picker>
                @if(mailingListCountError) {
                    <agpr-form-message
                        [id]="'mailingList_errors'"
                        class="agpr-shareCanvasDialog-errorMessage"
                    >
                        {{ 'Briefings.input.mailingLists.validation' | localize }}
                    </agpr-form-message>
                }
            </div>
            <div class="agpr-inputGroup">
                <agpr-email-chips
                    [id]="`${id}_recipients`"
                    class="agpr-shareCanvasDialog-recipients"
                    header="Briefings.input.recipients"
                    [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                    clearAllChipsTooltip="Briefings.input.recipients.clearAllTooltip"
                    [(value)]="recipientList"
                    (valueChange)="recipientListChanged()"
                    [ariaInvalid]="recipientListError"
                    ariaDescribedBy="recipient_errors"
                ></agpr-email-chips>
            </div>
            <div class="agpr-inputGroup">
                <agpr-checkbox
                    [id]="`${id}_excludeSubscribedRecipients`"
                    class="agpr-shareCanvasDialog-excludeSubscribedRecipients"
                    label="Briefings.shareCanvas.checkbox.excluedSubscribedRecipients"
                    [binary]="true"
                    [(ngModel)]="excludeSubscribedRecipients"
                    (ngModelChange)="excludeSubscribedRecipientsChanged()"
                ></agpr-checkbox>
            </div>
            @if (recipientListError) {
                <agpr-form-message
                    [id]="'recipient_errors'"
                    class="agpr-shareCanvasDialog-errorMessage"
                >
                    {{ 'Briefings.input.recipients.validation' | localize }}
                </agpr-form-message>
            }
            <div class="agpr-shareCanvasDialog-header">
                {{ 'Briefings.shareCanvas.heading.inviteDetails' | localize }}
            </div>
            <div class="agpr-inputGroup">
                <agpr-text-input
                    [id]="`${id}_fromName`"
                    class="agpr-shareCanvasDialog-fromName"
                    [label]="'Briefings.input.fromName'"
                    [placeholder]="'Briefings.input.fromName.placeholder' | localize"
                    [maxLength]="maxInputTextLength"
                    [(ngModel)]="fromName"
                    (ngModelChange)="fromNameChanged()"
                    [ariaInvalid]="fromNameError"
                    ariaDescribedBy="fromName_errors"
                    [bottomMargin]="false"
                ></agpr-text-input>
            </div>
            @if (fromNameError) {
                <agpr-form-message
                    [id]="'fromName_errors'"
                    class="agpr-shareCanvasDialog-errorMessage"
                >
                    {{ 'Briefings.input.fromName.validation' | localize }}
                </agpr-form-message>
            }
            <div class="agpr-inputGroup">
                <agpr-text-input
                    [id]="`${id}_replyTo`"
                    class="agpr-shareCanvasDialog-replyTo"
                    [label]="'Briefings.input.replyTo'"
                    [placeholder]="'Briefings.input.replyTo.placeholder' | localize"
                    [maxLength]="maxInputTextLength"
                    [(ngModel)]="replyTo"
                    (ngModelChange)="replyToChanged()"
                    [ariaInvalid]="replyToInvalid || replyToError"
                    ariaDescribedBy="replyTo_errors"
                    [bottomMargin]="false"
                ></agpr-text-input>
            </div>
            @if (replyToInvalid || replyToError) {
                <ul
                    id="replyTo_errors"
                    class="agpr-shareCanvasDialog-errorMessageList"
                >
                    @if (replyToError) {
                        <li class="agpr-shareCanvasDialog-errorMessageListItem">
                            <agpr-form-message class="agpr-shareCanvasDialog-errorMessage">
                                {{ 'Briefings.input.replyTo.validation' | localize }}
                            </agpr-form-message>
                        </li>
                    }

                    @if (replyToInvalid) {
                        <li class="agpr-shareCanvasDialog-errorMessageListItem">
                            <agpr-form-message class="agpr-shareCanvasDialog-errorMessage">
                                {{ 'invalidEmailFormat' | localize }}
                            </agpr-form-message>
                        </li>
                    }
                </ul>
            }
            <div class="agpr-inputGroup">
                <agpr-textarea-input
                    [id]="`${id}_inviteMessage`"
                    class="agpr-shareCanvasDialog-inviteMessage"
                    label="Briefings.input.inviteMessage"
                    [placeholder]="'Briefings.input.inviteMessage.placeholder'"
                    [maxLength]="maxTextareaLength"
                    [rows]="textareaRowNumber"
                    [(ngModel)]="inviteMessage"
                    [resize]="resizeDirectionEnum.none"
                ></agpr-textarea-input>
            </div>
        </div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            [id]="`${id}_cancel`"
            label="Core.button.cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="`${id}_share`"
            label="Briefings.shareCanvas.button.share"
            [style]="buttonType.primary"
            [loading]="shareLoading"
            (click)="shareCanvas()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
